/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Global } from '@emotion/react';

export default function GlobalStyles({ colors }) {
  return (
    <Global
      styles={{
        ':root': {
          '--featured-1': 'span 12',
          '--featured-2': 'span 12',
          '--featured-3': 'span 12',
          '--featured-4': 'span 12',

          scrollBehavior: 'smooth',
          minWidth: '320px',

          '@media screen and (min-width: 992px)': {
            '--featured-1': 'span 8',
            '--featured-2': 'span 6',
            '--featured-3': 'span 6',
            '--featured-4': 'span 6',
          },
        },
        '*': {
          boxSizing: 'border-box',
        },
        body: {
          backgroundColor: colors.background,
          color: colors.text,
          margin: '0',
        },
      }}
    />
  );
}
